export default __webpack_public_path__ + "static/media/MultipleDevices.aa45b875.svg";